import {Action} from '@ngrx/store';
import {
  ChallengeAlert,
  ChallengeBuilderLaunch,
  ChallengeBuilderProject,
  ChallengeBuilderPrompt,
  ChallengeGoal,
  ChallengeMetric,
  ChallengeObjective,
  ChallengeReward,
  ChallengeSalvage,
  ChallengeTarget,
  ChallengeTask,
} from '../../model/project';

export enum ChallengeBuilderActionType {
  GET_CHALLENGE_BUILDER_PROJECT = '[Challenge Builder] Get Challenge Builder Project',
  SET_CHALLENGE_BUILDER_LOADING = '[Challenge Builder] Set Challenge Builder Loading',
  CHALLENGE_REFINE_GOAL = '[Challenge Builder] Challenge Refine Goal',
  CHALLENGE_GOAL = '[Challenge Builder] Challenge Goal',
  CHALLENGE_OBJECTIVES = '[Challenge Builder] Challenge Objectives',
  CHALLENGE_TASKS = '[Challenge Builder] Challenge Tasks',
  CHALLENGE_METRICS = '[Challenge Builder] Challenge Metrics',
  CHALLENGE_TARGETS = '[Challenge Builder] Challenge Targets',
  CHALLENGE_SCHEDULE = '[Challenge Builder] Challenge Schedule',
  START_CHALLENGE = '[Challenge Builder] Start Challenge',
  STOP_CHALLENGE = '[Challenge Builder] Stop Challenge',
  UPDATE_CHALLENGE_BUILDER_PROJECT = '[Challenge Builder] Update Challenge Builder Project',
  SET_NEXT_LOADING = '[Challenge Builder] Set Next Loading',
  SET_BACK_LOADING = '[Challenge Builder] Set Back Loading',
  UPDATE_CHALLENGE_NEXT_VALID = '[Challenge Builder] Update Challenge Next Valid',
  CLEAR = '[Challenge Builder] Clear',
  GET_CHALLENGE_BUILDER_PROMPTS = '[Challenge Builder] Get Challenge Builder Prompts',
  UPDATE_CHALLENGE_BUILDER_PROMPTS = '[Challenge Builder] Update Challenge Builder Prompts',
  SET_CHALLENGE_BUILDER_PROMPTS = '[Challenge Builder] Set Challenge Builder Prompts',
  ADD_SALVAGE = '[Challenge Builder] Add Salvage',
  UPDATE_SALVAGE = '[Challenge Builder] Update Salvage',
  DELETE_SALVAGE = '[Challenge Builder] Delete Salvage',
  ADD_REWARD = '[Challenge Builder] Add Reward',
  UPDATE_REWARD = '[Challenge Builder] Update Reward',
  DELETE_REWARD = '[Challenge Builder] Delete Reward',
  ADD_ALERT = '[Challenge Builder] Add Alert',
  UPDATE_ALERT = '[Challenge Builder] Update Alert',
  DELETE_ALERT = '[Challenge Builder] Delete Alert',
  UPDATE_TASK_ICON = '[Challenge Builder] Update Task Icon',
  TOGGLE_AI = '[Challenge Builder] Toggle AI',
}

export class GetChallengeBuilderProjectAction implements Action {
  public readonly type = ChallengeBuilderActionType.GET_CHALLENGE_BUILDER_PROJECT;

  public constructor(
    public payload: {
      projectId: string;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class SetChallengeBuilderLoadingAction implements Action {
  public readonly type = ChallengeBuilderActionType.SET_CHALLENGE_BUILDER_LOADING;

  public constructor(public payload: {loading: boolean}) {}
}

export class ChallengeRefineGoalAction implements Action {
  public readonly type = ChallengeBuilderActionType.CHALLENGE_REFINE_GOAL;

  public constructor(
    public payload: {
      projectId: string;
      initialGoal: string;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ChallengeGoalAction implements Action {
  public readonly type = ChallengeBuilderActionType.CHALLENGE_GOAL;

  public constructor(
    public payload: {
      projectId: string;
      goals: ChallengeGoal[];
      goalAltered: boolean;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ChallengeObjectivesAction implements Action {
  public readonly type = ChallengeBuilderActionType.CHALLENGE_OBJECTIVES;

  public constructor(
    public payload: {
      projectId: string;
      objectives: ChallengeObjective[];
      objectivesAltered: ChallengeObjective[];
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ChallengeTasksAction implements Action {
  public readonly type = ChallengeBuilderActionType.CHALLENGE_TASKS;

  public constructor(
    public payload: {
      projectId: string;
      tasks: ChallengeTask[];
      tasksAltered: ChallengeTask[];
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ChallengeMetricsAction implements Action {
  public readonly type = ChallengeBuilderActionType.CHALLENGE_METRICS;

  public constructor(
    public payload: {
      projectId: string;
      metrics: ChallengeMetric[];
      metricsAltered: ChallengeMetric[];
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ChallengeTargetsAction implements Action {
  public readonly type = ChallengeBuilderActionType.CHALLENGE_TARGETS;

  public constructor(
    public payload: {
      projectId: string;
      targets: ChallengeTarget[];
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ChallengeScheduleAction implements Action {
  public readonly type = ChallengeBuilderActionType.CHALLENGE_SCHEDULE;

  public constructor(
    public payload: {
      projectId: string;
      tasks: ChallengeTask[];
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class StartChallengeAction implements Action {
  public readonly type = ChallengeBuilderActionType.START_CHALLENGE;

  public constructor(
    public payload: {
      projectId: string;
      launchData: ChallengeBuilderLaunch;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class StopChallengeAction implements Action {
  public readonly type = ChallengeBuilderActionType.STOP_CHALLENGE;

  public constructor(
    public payload: {
      projectId: string;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class UpdateChallengeBuilderProjectAction implements Action {
  public readonly type = ChallengeBuilderActionType.UPDATE_CHALLENGE_BUILDER_PROJECT;

  public constructor(public payload: {cbProject: ChallengeBuilderProject}) {}
}

export class SetNextLoadingAction implements Action {
  public readonly type = ChallengeBuilderActionType.SET_NEXT_LOADING;

  public constructor(public payload: {nextLoading: boolean}) {}
}

export class SetBackLoadingAction implements Action {
  public readonly type = ChallengeBuilderActionType.SET_BACK_LOADING;

  public constructor(public payload: {backLoading: boolean}) {}
}

export class UpdateChallengeNextValidAction implements Action {
  public readonly type = ChallengeBuilderActionType.UPDATE_CHALLENGE_NEXT_VALID;

  public constructor(public payload: {valid: boolean}) {}
}

export class ClearChallengeBuilderAction implements Action {
  public readonly type = ChallengeBuilderActionType.CLEAR;
}

export class GetChallengeBuilderPromptsAction implements Action {
  public readonly type = ChallengeBuilderActionType.GET_CHALLENGE_BUILDER_PROMPTS;

  public constructor(
    public payload: {
      onSuccess?: (prompts: ChallengeBuilderPrompt[]) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class UpdateChallengeBuilderPromptsAction implements Action {
  public readonly type = ChallengeBuilderActionType.UPDATE_CHALLENGE_BUILDER_PROMPTS;

  public constructor(
    public payload: {
      prompts: ChallengeBuilderPrompt[];
      onSuccess?: (prompts: ChallengeBuilderPrompt[]) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class SetChallengeBuilderPromptsAction implements Action {
  public readonly type = ChallengeBuilderActionType.SET_CHALLENGE_BUILDER_PROMPTS;

  public constructor(public payload: {prompts: ChallengeBuilderPrompt[]}) {}
}

export class AddSalvageAction implements Action {
  public readonly type = ChallengeBuilderActionType.ADD_SALVAGE;

  public constructor(
    public payload: {
      projectId: string;
      salvage: ChallengeSalvage;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class AddRewardAction implements Action {
  public readonly type = ChallengeBuilderActionType.ADD_REWARD;

  public constructor(
    public payload: {
      projectId: string;
      reward: ChallengeReward;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class AddAlertAction implements Action {
  public readonly type = ChallengeBuilderActionType.ADD_ALERT;

  public constructor(
    public payload: {
      projectId: string;
      alert: ChallengeAlert;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class UpdateSalvageAction implements Action {
  public readonly type = ChallengeBuilderActionType.UPDATE_SALVAGE;

  public constructor(
    public payload: {
      projectId: string;
      salvage: ChallengeSalvage;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class DeleteSalvageAction implements Action {
  public readonly type = ChallengeBuilderActionType.DELETE_SALVAGE;

  public constructor(
    public payload: {
      projectId: string;
      salvageId: string;
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class UpdateRewardAction implements Action {
  public readonly type = ChallengeBuilderActionType.UPDATE_REWARD;

  public constructor(
    public payload: {
      projectId: string;
      reward: ChallengeReward;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class DeleteRewardAction implements Action {
  public readonly type = ChallengeBuilderActionType.DELETE_REWARD;

  public constructor(
    public payload: {
      projectId: string;
      rewardId: string;
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class UpdateAlertAction implements Action {
  public readonly type = ChallengeBuilderActionType.UPDATE_ALERT;

  public constructor(
    public payload: {
      projectId: string;
      alert: ChallengeAlert;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class DeleteAlertAction implements Action {
  public readonly type = ChallengeBuilderActionType.DELETE_ALERT;

  public constructor(
    public payload: {
      projectId: string;
      alertId: string;
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class UpdateTaskIconAction implements Action {
  public readonly type = ChallengeBuilderActionType.UPDATE_TASK_ICON;

  public constructor(
    public payload: {
      projectId: string;
      taskId: string;
      icon: string;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ToggleAiAction implements Action {
  public readonly type = ChallengeBuilderActionType.TOGGLE_AI;

  public constructor(
    public payload: {
      projectId: string;
      onSuccess?: (cbProject: ChallengeBuilderProject) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export type ChallengeBuilderAction =
  | GetChallengeBuilderProjectAction
  | SetChallengeBuilderLoadingAction
  | ChallengeRefineGoalAction
  | ChallengeGoalAction
  | ChallengeObjectivesAction
  | ChallengeTasksAction
  | ChallengeMetricsAction
  | ChallengeTargetsAction
  | ChallengeScheduleAction
  | StartChallengeAction
  | StopChallengeAction
  | UpdateChallengeBuilderProjectAction
  | SetNextLoadingAction
  | SetBackLoadingAction
  | UpdateChallengeNextValidAction
  | ClearChallengeBuilderAction
  | GetChallengeBuilderPromptsAction
  | UpdateChallengeBuilderPromptsAction
  | SetChallengeBuilderPromptsAction
  | AddSalvageAction
  | UpdateSalvageAction
  | DeleteSalvageAction
  | AddRewardAction
  | UpdateRewardAction
  | DeleteRewardAction
  | AddAlertAction
  | UpdateAlertAction
  | DeleteAlertAction
  | UpdateTaskIconAction
  | ToggleAiAction;
